import Button from 'components/field/Button';
import Typography from 'components/global/Typography';

const UrlViewer = ({ value }) =>
	value?.includes('http://') || value?.includes('https://') ? (
		<Button
			variant="blueBorderless"
			onClick={() => {
				window.open(value, '_blank');
			}}
			fullWidth>
			<Typography color="var(--blue)" showCopyButton>
				{value}
			</Typography>
		</Button>
	) : (
		<Typography showCopyButton>{value}</Typography>
	);

export default UrlViewer;
